import { render, staticRenderFns } from "./product-without-content.vue?vue&type=template&id=5e0d1d90"
import script from "./product-without-content.vue?vue&type=script&lang=js"
export * from "./product-without-content.vue?vue&type=script&lang=js"
import style0 from "./product-without-content.vue?vue&type=style&index=0&id=5e0d1d90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
